import React from 'react';
import classNames from 'classnames';
import { IClearingStepProps } from './';
import { useModal } from '@features/Modal';
import { TradeBreaksModal } from '@widgets/Current/components';
import './ClearingStep.scss';

const STATUSES = {
    NotRun: {
        name: 'Waiting',
        styles: {
            borderColor: '#DBEAFE',
            backgroundColor: '#EFF6FF',
        },
        textStyles: {
            color: '#2563EB',
        },
        icon: () => <etna-icon name='Clock' />,
    },
    Waiting: {
        name: 'Waiting',
        styles: {
            borderColor: '#DBEAFE',
            backgroundColor: '#EFF6FF',
        },
        textStyles: {
            color: '#2563EB',
        },
        icon: () => <etna-icon name='Clock' />,
    },
    Working: {
        name: 'Processing',
        styles: {
            borderColor: '#FEF08A',
            backgroundColor: '#FEFCE8',
        },
        textStyles: {
            color: '#A16207',
        },
        icon: () => <etna-icon name='Refresh' />,
    },
    Done: {
        name: 'Done',
        styles: {
            borderColor: '#CEF5E6',
            backgroundColor: '#ECFDF6',
        },
        textStyles: {
            color: '#18966F',
        },
        icon: () => <etna-icon name='FileCheck' />,
    },
    Error: {
        name: 'Failed',
        styles: {
            borderColor: '#FEE2E2',
            backgroundColor: '#FCF1F1',
        },
        textStyles: {
            color: '#DC2626',
        },
        icon: () => <etna-icon name='Warning' />,
    },
    Disabled: {
        name: 'Disabled',
        styles: {
            borderColor: '#EDEFF2',
            backgroundColor: '#F7F9FA',
        },
        textStyles: {
            color: '#4B5563',
        },
        icon: () => <etna-icon name='Close' />,
    },
    NeedApproval: {
        name: 'Need Approval',
        styles: {
            borderColor: '#FFEDD5',
            backgroundColor: '#FFF7ED',
        },
        textStyles: {
            color: '#EA580C',
        },
        icon: () => <etna-icon name='Refresh' />,
    },
};

export const ClearingStep: React.FC<IClearingStepProps> = ({ currentSettlement, needApproval }) => {
    const currentStatus = STATUSES[needApproval ? 'NeedApproval' : currentSettlement.status];
    const { open: openTradeBreaksModal } = useModal(TradeBreaksModal);

    const onStatusClick = () => {
        if (currentSettlement.status !== 'Error' || !currentSettlement.additionalData) {
            return;
        }
        const parsedAdditionalData = JSON.parse(currentSettlement.additionalData);

        openTradeBreaksModal({ currentSettlement, parsedAdditionalData });
    };

    return (
        <div
            className={classNames('status-block', { error: currentSettlement.status === 'Error' })}
            style={currentStatus.styles}
            onClick={onStatusClick}
        >
            <currentStatus.icon />
            <span
                style={currentStatus.textStyles}
                className='status-block__status'
            >
                {currentStatus.name}
            </span>
        </div>
    );
};
